import { ChangeEvent } from 'react';

export const PARENT_CONTACT_STEPS = {
  PHONE: 'phone',
  OTP: 'otp',
  SUCCESS: 'success'
} as const;

export type ParentContactStep =
  typeof PARENT_CONTACT_STEPS[keyof typeof PARENT_CONTACT_STEPS];

export interface ParentContactCountry {
  code: string;
  phoneCode?: string;
  phone_code?: string;
}

export const PARENT_CONTACT_PHONE_MAX_LENGTH = 10;

export const validateNumber = (
  event: ChangeEvent<HTMLInputElement>,
  maxLength?: number
) => {
  const { target } = event;
  let sanitized = target.value.replace(/[^0-9]/g, '');
  if (maxLength !== undefined) {
    sanitized = sanitized.slice(0, maxLength);
  }
  target.value = sanitized;
};

export const formatPhoneDisplay = (
  country: ParentContactCountry | null,
  phone: string
) => `+${country?.phoneCode || country?.phone_code || ''} ${phone}`;

export const getCountryCodeForApi = (country: ParentContactCountry | null) =>
  country?.code?.toUpperCase() || '';

export const getCountryByCode = (
  countries: ParentContactCountry[],
  countryCode?: string
) =>
  countries?.find(
    (c) => c.code?.toLowerCase() === countryCode?.toLowerCase()
  ) ?? null;

export const getResponseMessage = (
  response?: {
    message?: string;
    error?: { message?: string };
  } | null
) => response?.error?.message || response?.message;
